if (document.getElementById('module-ve_custom_pages-appstoresredirect')) {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.vasco.connect&hl=en';
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    window.location.href = 'https://apps.apple.com/eg/app/vasco-connect/id6468865038';
  }
}
